angular.module('harriApp')

.directive('groupFilter',['$timeout', function( $timeout ){
	return {
		restrict: 'E',
		replace: 'true',
    require: 'ngModel',
		scope: {
		    'label': '@',
		    'group': '@',
        'model' : '=ngModel',
		},
        templateUrl: '../modules/search/views/partials/group-filter.html',
		link: function (scope, iElement, iAttrs) {

			iElement.on('click',function(){

				scope.$apply(function(){
					scope.model = scope.group;
				});

			});

            scope.$watch( 'model', function () { console.log( scope.model ) } );

		}
    }
}])

.directive('memberWidget', [function () {
	return {
		restrict: 'E',
		scope:{
			'data' : '='
		},
		replace: 'true',
        templateUrl: '../modules/search/views/partials/member_widget.html'
	};
}])

.directive('jobWidget', function() {
    return {
        restrict: "E",
        scope:{
        	'data' : '='
        },
        replace: 'true',
        templateUrl: '../modules/search/views/partials/job_widget_2.html'
    };
})


.directive('brandWidget', function() {
    return {
        restrict: "E",
        scope:{
        	'data' : '='
        },
        replace: 'true',
        templateUrl: '../modules/search/views/partials/brand_widget.html'
    };
})
